import MultipleEventTracker from './MultipleEventTracker';

const ShipperOrderTracking = new MultipleEventTracker();
const JourneyTracking = new MultipleEventTracker();

export { ShipperOrderTracking, JourneyTracking };
